export const filterLinkToProductReviews = (url: string): string =>
  `${url}#reviews`
